import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import fpFetch from "../../services/fpFetch";
import { BASE_API_URL } from "../../constants";
import { resetFpAppV4Data, updateFpAppV4Data } from "../../redux/fpAppV4Slice";
import { handleError } from "../../utils/handleError";

export function NewReportRedirect() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const creating = useRef(false);

  useEffect(() => {
    if (creating.current) return;
    creating.current = true;

    const create = async () => {
      try {
        const id = uuidv4();
        const type = "private_doc_editor";

        dispatch(resetFpAppV4Data());

        dispatch(
          updateFpAppV4Data({
            workspaceId: id,
            title: "New Report",
            type,
            trigger: "clean_editor",
          })
        );

        await fpFetch(`${BASE_API_URL}/workspaces/update`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ _id: id, title: "New Report", type }),
        });

        navigate(`/reports/${id}`, { replace: true });
      } catch (e) {
        handleError({ error: e, location: "NewReportRedirect" });
        navigate("/reports", { replace: true });
      }
    };

    create();
  }, [navigate, dispatch]);

  return null;
}

export function NewMatrixRedirect() {
  const navigate = useNavigate();
  const creating = useRef(false);

  useEffect(() => {
    if (creating.current) return;
    creating.current = true;

    const create = async () => {
      try {
        const id = uuidv4();

        await fpFetch(`${BASE_API_URL}/workspaces/update`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            _id: id,
            type: "querygrid",
            title: "New Matrix",
            content: "",
            meta: {},
          }),
        });

        navigate(`/matrix/${id}?sidepanel=setup`, { replace: true });
      } catch (e) {
        console.error("Error creating matrix:", e);
        navigate("/matrix", { replace: true });
      }
    };

    create();
  }, [navigate]);

  return null;
}
